import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";
import { IMAGES } from "../../data/content";
import { fade } from "../../lib/motion";

export const Hero = ({ onJoin }) => {
  const scrollTo = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section
      data-testid="hero-section"
      className="grain-overlay relative flex min-h-screen items-end overflow-hidden sm:items-center"
    >
      <img
        src={IMAGES.hero}
        alt="Comunidade de mulheres cristãs do Ministério AURA"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#1A1816]/85 via-[#1A1816]/40 to-[#1A1816]/20" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#1A1816]/50 to-transparent" />

      <div className="relative z-10 mx-auto w-full max-w-7xl px-5 pb-20 pt-32 sm:px-6 sm:py-40 lg:px-8">
        <motion.div
          {...fade(0.1)}
          data-testid="hero-badge"
          className="inline-flex items-center gap-3 rounded-full border border-champagne/30 bg-white/10 px-5 py-2 backdrop-blur-md"
        >
          <img
            src={IMAGES.logo}
            alt="Logo Ministério AURA"
            className="h-10 w-10 rounded-full object-cover drop-shadow-[0_2px_12px_rgba(197,160,89,0.55)]"
          />
          <span className="text-xs font-semibold uppercase tracking-[0.3em] text-champagne">
            Ministério AURA
          </span>
        </motion.div>

        <motion.p
          {...fade(0.3)}
          className="mt-12 max-w-2xl font-serif text-lg italic text-champagne/90 sm:text-2xl"
        >
          "Existe uma mulher dentro de você que ainda precisa descobrir a força
          de quem ela é."
        </motion.p>
        <motion.p
          {...fade(0.5)}
          className="mt-4 max-w-2xl font-serif text-lg italic text-white/85 sm:text-2xl"
        >
          "Ela é filha de um Rei. Ela tem identidade. Ela tem propósito. Ela tem
          lugar. E ela foi chamada para servir."
        </motion.p>

        <motion.h1
          {...fade(0.7)}
          className="mt-8 font-serif text-4xl leading-[1.05] text-white sm:text-5xl lg:text-7xl"
        >
          Bem-vinda ao AURA.
          <span className="block text-champagne">
            O chamado ao sacerdócio real.
          </span>
        </motion.h1>

        <motion.div {...fade(0.9)} className="mt-10 flex flex-col gap-4 sm:flex-row">
          <button
            data-testid="hero-join-cta"
            onClick={onJoin}
            className="animate-pulse-glow rounded-full bg-teal px-9 py-4 text-xs font-semibold uppercase tracking-[0.2em] text-white transition-colors duration-300 hover:bg-teal-hover sm:text-sm"
          >
            Quero fazer parte do AURA
          </button>
          <button
            data-testid="hero-discover-cta"
            onClick={() => scrollTo("movimento")}
            className="rounded-full border border-champagne/60 px-9 py-4 text-xs font-semibold uppercase tracking-[0.2em] text-champagne transition-colors duration-300 hover:border-champagne hover:bg-champagne/10 sm:text-sm"
          >
            Descobrir o movimento
          </button>
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.6, duration: 1 }}
        className="absolute bottom-8 left-1/2 z-10 hidden -translate-x-1/2 flex-col items-center gap-2 text-champagne/80 sm:flex"
      >
        <span className="text-[10px] uppercase tracking-[0.3em]">Role</span>
        <ArrowDown className="h-4 w-4 animate-bounce" />
      </motion.div>
    </section>
  );
};
